import { render, staticRenderFns } from "./UnavailableMaterialInVisitsStatistics.vue?vue&type=template&id=31d04ef5"
import script from "./UnavailableMaterialInVisitsStatistics.vue?vue&type=script&lang=js"
export * from "./UnavailableMaterialInVisitsStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports